const zh = {
    title: "精修审核",
    admin: "新建精修审核",
    manage: "精修审核管理",
    days: "{count}天",
    editProject: "编辑项目",
    saveChanges: "保存修改",
    updated: "项目已更新",
    editPathHint: "修改 R2 根目录不会自动搬移已有文件，请确认新目录已准备好。",
    poster: "生成海报",
    posterTitle: "精修审核海报",
    posterSubtitle: "RETOUCHED PHOTO REVIEW",
    posterScan: "扫码打开精修审核",
    posterExpiry: "链接有效期至",
    posterDownload: "下载海报",
    posterLoading: "海报准备中…",
    posterFailed: "海报生成失败",
    posterDownloadFailed: "海报下载失败",
    posterLinkCopied: "链接已复制",
    subtitle: "上传 original 与多个精修版本，让客户直接对照并提出修改意见。",
    path: "R2 根目录",
    name: "项目名称",
    expiry: "链接过期时间",
    create: "创建项目",
    adminNamePlaceholder: "2026年7月精修",
    createDone: "项目已创建",
    createFailed: "创建失败",
    copyClient: "复制客户链接",
    copyEditor: "复制修图师链接",
    linkCopied: "链接已复制",
    loadFailed: "加载失败",
    empty: "还没有精修审核项目。",
    sync: "同步 R2",
    publish: "同步并发布",
    upload: "批量上传",
    audit: "打开审核",
    delete: "删除项目",
    deleteTitle: "删除精修审核项目",
    deleteHint: "此操作会删除该项目关联的 R2 文件和 D1 数据，且不可恢复。请输入项目名称确认。",
    deleteConfirm: "输入项目名称",
    cancel: "取消",
    confirmDelete: "确认删除",
    deleted: "项目已删除",
    uploadTitle: "批量上传精修文件",
    uploadCurrentTitle: "为这张照片上传新版本",
    chooseFolder: "先选择版本，再多选需要上传的照片",
    chooseCurrentFile: "选择替换照片",
    chooseSingleFile: "选择一张照片",
    singleFileOnly: "单张上传一次只能选择一张照片",
    singleFileFormatError: "单张上传仅支持 .jpg 格式",
    singleUploadFormatHint: "单张上传仅支持 .jpg 格式。文件名必须与当前照片一致。",
    singleUploadFilenameHint: "当前照片文件名：{filename}",
    batchUploadFormatHint: "批量上传仅支持 .jpg 格式。",
    batchUploadFilenameHint: "请选择与 original 老版本相同文件名（含子文件夹）的 JPG 照片；latest 会按每张照片自动创建下一版本。",
    fileFormatError: "以下文件格式不支持：{files}",
    jpgOnlyFormatError: "上传仅支持 .jpg 格式：{files}",
    batchFilenameMismatchTitle: "批量上传文件名不匹配",
    batchFilenameMismatch: "以下文件没有找到对应的 original 老版本，请检查文件名和子文件夹后重新选择。",
    understood: "知道了",
    uploadFailed: "上传失败",
    selected: "已选择",
    singleFilenameMismatchTitle: "照片文件名不匹配",
    singleFilenameMismatch: "你选择的文件“{selected}”与当前照片文件名“{expected}”不匹配，请确认上传的是正确的照片。",
    singleFilenameMismatchHint: "确认后，系统会按当前照片的正确文件名写入新的精修版本文件夹。",
    singleFilenameMismatchConfirm: "确认并继续",
    chooseFiles: "选择照片（可多选）",
    selectVersion: "批量设置版本",
    latestVersion: "latest（每张照片自动创建下一个版本）",
    startUpload: "开始上传",
    uploading: "正在上传",
    uploadDone: "上传完成",
    compareTitle: "上传对照检查",
    rescan: "重新扫描",
    continueUpload: "继续上传缺失文件",
    confirmSync: "确认并同步",
    originalCount: "original 数量",
    matched: "正确配对",
    missing: "缺失",
    extra: "多余",
    invalid: "无效文件",
    complete: "完整",
    missingStatus: "缺少版本",
    extraStatus: "多余文件",
    noFiles: "没有识别到 original/vN 文件",
    noRetouchVersion: "无精修版本",
    reviewLoadFailed: "无法加载审核项目",
    expired: "审核链接已过期或无效",
    enterNameTitle: "请填写审核人姓名",
    enterName: "姓名仅用于标识本次审核，方便摄影师确认是谁提交了评论或批准。",
    enterNamePlaceholder: "请输入您的姓名",
    wechatBrowserTitle: "微信浏览器兼容性提示",
    wechatBrowserMessage: "微信浏览器可能存在兼容性问题，打开高清精修图时可能出现拖影、页面错乱等情况，无法正常预览。建议复制链接后，粘贴到系统默认浏览器打开。",
    wechatBrowserOpenHint: "也可以点击微信右上角菜单，选择在浏览器中打开。",
    wechatBrowserCopyLink: "复制精修链接",
    wechatBrowserCopied: "精修链接已复制",
    wechatBrowserCopyFailed: "复制失败，请手动复制下方链接",
    wechatBrowserClose: "继续使用微信",
    startReview: "开始审核",
    continue: "进入审核",
    original: "原图",
    latest: "最新精修",
    edit: "添加标记",
    view: "退出标记",
    version: "版本",
    versionLabel: "版本{number}",
    comment: "修改建议",
    commentPlaceholder: "请填写修改建议",
    send: "提交建议",
    approve: "批准当前版本",
    approvedVersion: "{version}已批准",
    approvalComment: "{version}已批准",
    download: "下载当前版本",
    downloadLabel: "下载",
    downloadAll: "下载所有照片",
    downloadAllMobileTitle: "保存所有照片",
    downloadAllMobileHint: "请长按每张照片，然后选择「存储到照片」",
    downloadAllMobileCount: "共 {count} 张",
    downloadAllProgress: "正在打包 {current}/{total}",
    downloadAllStarted: "已开始打包下载",
    downloadAllPartial: "已打包 {succeeded} 张，{failed} 张失败",
    downloadAllUnsupported: "当前浏览器不支持流式打包下载，请改用桌面端 Chrome/Edge，或在移动端逐张长按保存",
    uploadCurrent: "上传这张新版本",
    downloading: "正在下载",
    downloaded: "下载已开始",
    downloadFailed: "下载失败",
    noComments: "暂无评论",
    saveComment: "评论已提交",
    drawingHint: "可以在图片上圈画给出标记",
    zoomIn: "放大",
    zoomOut: "缩小",
    photoZoomHint: "Ctrl/⌘ + 滚轮缩放照片",
    clearDrawing: "清除圈画",
    resetZoom: "重置缩放",
    previous: "上一张",
    next: "下一张",
    readOnly: "当前链接只读",
    fullscreen: "单张查看",
    exitFullscreen: "关闭预览",
    closePreview: "关闭预览",
    showOriginal: "显示原图",
    showRetouched: "显示精修图",
    hideOriginal: "隐藏原图",
    mobileSaveTitle: "保存照片",
    mobileSaveHint: "请长按图片，然后选择「存储到照片」",
    autoSyncDone: "上传完成，R2 已自动同步",
    fullscreenFailed: "无法进入预览",
    retoucherTitle: "修图师分享链接",
    retoucher: "修图师",
    gallery: "所有精修照片",
    allPhotos: "所有照片",
    openGallery: "打开所有精修照片",
    closeGallery: "收起所有精修照片",
    customerTitle: "客户精修审核",
    photographer: "摄影师",
    customer: "客户",
    loading: "加载中…",
    deleteComment: "删除",
    statusPending: "待上传",
    statusUploading: "上传中",
    statusUploaded: "已上传",
    statusFailed: "失败",
    selectedFiles: "已选择 {count} 个文件",
    invalidRoot: "请输入有效的 R2 根目录",
    projectNameRequired: "请输入项目名称",
    expiryFuture: "过期时间必须晚于现在",
    expiredStatus: "已过期",
    active: "有效",
    deleting: "删除中",
    deleteFailed: "删除失败",
};

const en = {
    title: "Retouch review",
    admin: "New retouch review",
    manage: "Retouch reviews",
    days: "{count} days",
    editProject: "Edit project",
    saveChanges: "Save changes",
    updated: "Project updated",
    editPathHint: "Changing the R2 root does not move existing files. Make sure the new folder is ready.",
    poster: "Generate poster",
    posterTitle: "Retouch review poster",
    posterSubtitle: "RETOUCHED PHOTO REVIEW",
    posterScan: "Scan to open retouch review",
    posterExpiry: "Link valid until",
    posterDownload: "Download poster",
    posterLoading: "Preparing poster…",
    posterFailed: "Poster generation failed",
    posterDownloadFailed: "Poster download failed",
    posterLinkCopied: "Link copied",
    subtitle: "Upload original and retouched versions for side-by-side client feedback.",
    path: "R2 root",
    name: "Project name",
    expiry: "Link expiry",
    create: "Create project",
    adminNamePlaceholder: "July 2026 retouch",
    createDone: "Project created",
    createFailed: "Create failed",
    copyClient: "Copy client link",
    copyEditor: "Copy retoucher link",
    linkCopied: "Link copied",
    loadFailed: "Load failed",
    empty: "No retouch projects yet.",
    sync: "Sync R2",
    publish: "Sync and publish",
    upload: "Batch upload",
    audit: "Open review",
    delete: "Delete project",
    deleteTitle: "Delete retouch project",
    deleteHint: "This deletes all project R2 files and D1 data and cannot be undone. Type the project name to confirm.",
    deleteConfirm: "Project name",
    cancel: "Cancel",
    confirmDelete: "Delete",
    deleted: "Project deleted",
    uploadTitle: "Batch upload",
    uploadCurrentTitle: "Upload a new version for this photo",
    chooseFolder: "Select multiple photos, then set a target version for each photo",
    chooseCurrentFile: "Choose the replacement photo",
    chooseSingleFile: "Choose one photo",
    singleFileOnly: "Single-photo upload accepts only one file",
    singleFileFormatError: "Single-photo upload supports .jpg files only",
    singleUploadFormatHint: "Single-photo upload supports .jpg files only. The filename must match the current photo.",
    singleUploadFilenameHint: "Current photo filename: {filename}",
    batchUploadFormatHint: "Batch upload supports .jpg files only.",
    batchUploadFilenameHint: "Choose JPG files with the same filenames and subfolders as the original files; latest creates the next version separately for each photo.",
    fileFormatError: "These file formats are not supported: {files}",
    jpgOnlyFormatError: "Uploads support .jpg files only: {files}",
    batchFilenameMismatchTitle: "Batch filenames do not match",
    batchFilenameMismatch: "These files do not match any original file. Check their filenames and subfolders, then choose them again.",
    understood: "Got it",
    uploadFailed: "Upload failed",
    selected: "Selected",
    selectVersion: "Set version for all selected photos",
    latestVersion: "latest (auto-create the next version for each photo)",
    chooseFiles: "Choose photos (multiple allowed)",
    startUpload: "Start upload",
    uploading: "Uploading",
    uploadDone: "Upload complete",
    compareTitle: "Upload comparison",
    rescan: "Rescan",
    continueUpload: "Continue missing files",
    confirmSync: "Confirm and sync",
    originalCount: "Original count",
    matched: "Matched",
    missing: "Missing",
    extra: "Extra",
    invalid: "Invalid",
    complete: "Complete",
    missingStatus: "Missing version",
    extraStatus: "Extra file",
    noFiles: "No image files found",
    noRetouchVersion: "No retouched version",
    reviewLoadFailed: "Could not load review",
    expired: "Review expired or invalid",
    enterNameTitle: "Enter your name",
    enterName: "Your name is only used to identify this review, so the photographer knows who left feedback or approved a version.",
    enterNamePlaceholder: "Enter your name",
    wechatBrowserTitle: "WeChat browser compatibility notice",
    wechatBrowserMessage: "The WeChat browser may have compatibility issues with high-resolution retouched photos, causing ghosting or a broken layout. To preview correctly, copy the link and open it in your default browser.",
    wechatBrowserOpenHint: "You can also use WeChat's top-right menu to open this link in a browser.",
    wechatBrowserCopyLink: "Copy retouch link",
    wechatBrowserCopied: "Retouch link copied",
    wechatBrowserCopyFailed: "Copy failed. Please copy the link below manually.",
    wechatBrowserClose: "Continue in WeChat",
    startReview: "Start review",
    continue: "Continue",
    original: "Original",
    latest: "Latest",
    edit: "Add marker",
    view: "Exit marking",
    version: "Version",
    versionLabel: "Version {number}",
    comment: "Feedback",
    commentPlaceholder: "Describe the change",
    send: "Submit feedback",
    approve: "Approve current version",
    approvedVersion: "{version} approved",
    approvalComment: "{version} approved",
    download: "Download current version",
    downloadLabel: "Download",
    downloadAll: "Download all photos",
    downloadAllMobileTitle: "Save all photos",
    downloadAllMobileHint: "Long-press each photo, then choose \"Add to Photos\"",
    downloadAllMobileCount: "{count} photos",
    downloadAllProgress: "Packing {current}/{total}",
    downloadAllStarted: "Download started",
    downloadAllPartial: "Packed {succeeded} photos, {failed} failed",
    downloadAllUnsupported: "Streaming zip download is not supported in this browser. Use desktop Chrome/Edge, or long-press each photo to save on mobile.",
    uploadCurrent: "Upload new version",
    downloading: "Downloading",
    downloaded: "Download started",
    downloadFailed: "Download failed",
    noComments: "No comments",
    saveComment: "Feedback submitted",
    drawingHint: "Draw on the image to add a marker",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    photoZoomHint: "Ctrl/⌘ + scroll to zoom photo",
    clearDrawing: "Clear drawing",
    resetZoom: "Reset zoom",
    previous: "Previous",
    next: "Next",
    readOnly: "Read-only link",
    fullscreen: "View photo",
    exitFullscreen: "Close preview",
    closePreview: "Close preview",
    showOriginal: "Show original",
    showRetouched: "Show retouched",
    hideOriginal: "Hide original",
    mobileSaveTitle: "Save photo",
    mobileSaveHint: "Long-press the image, then choose \"Add to Photos\"",
    singleFilenameMismatchTitle: "Photo filename does not match",
    singleFilenameMismatch: "The selected file \"{selected}\" does not match the current photo filename \"{expected}\". Please confirm that this is the correct photo.",
    singleFilenameMismatchHint: "After confirmation, it will be stored with the current photo's correct filename in a new retouch version folder.",
    singleFilenameMismatchConfirm: "Confirm and continue",
    autoSyncDone: "Upload complete; R2 synced automatically",
    fullscreenFailed: "Could not open preview",
    retoucherTitle: "Retoucher share link",
    retoucher: "Retoucher",
    gallery: "All retouched photos",
    allPhotos: "All photos",
    openGallery: "Open all retouched photos",
    closeGallery: "Close all retouched photos",
    customerTitle: "Client retouch review",
    photographer: "Photographer",
    customer: "Client",
    loading: "Loading…",
    deleteComment: "Delete",
    statusPending: "Pending",
    statusUploading: "Uploading",
    statusUploaded: "Uploaded",
    statusFailed: "Failed",
    selectedFiles: "{count} files selected",
    invalidRoot: "Enter a valid R2 root",
    projectNameRequired: "Enter a project name",
    expiryFuture: "Expiry must be in the future",
    expiredStatus: "Expired",
    active: "Active",
    deleting: "Deleting",
    deleteFailed: "Delete failed",
};

const yue = {
    ...zh,
    wechatBrowserTitle: "微信瀏覽器兼容性提示",
    wechatBrowserMessage: "微信瀏覽器可能有兼容性問題，開啟高清精修相片時可能出現拖影、頁面錯亂等情況，未能正常預覽。建議複製連結後，貼到系統預設瀏覽器開啟。",
    wechatBrowserOpenHint: "你亦可以點擊微信右上角選單，選擇在瀏覽器中開啟。",
    wechatBrowserCopyLink: "複製精修連結",
    wechatBrowserCopied: "精修連結已複製",
    wechatBrowserCopyFailed: "複製失敗，請手動複製下方連結",
    wechatBrowserClose: "繼續使用微信",
    title: "精修審核",
    admin: "新增精修審核",
    manage: "精修審核管理",
    days: "{count}日",
    editProject: "編輯項目",
    saveChanges: "儲存修改",
    updated: "項目已更新",
    editPathHint: "修改 R2 根目錄不會自動搬移現有檔案，請確認新目錄已準備好。",
    poster: "生成海報",
    posterTitle: "精修審核海報",
    posterSubtitle: "RETOUCHED PHOTO REVIEW",
    posterScan: "掃描開啟精修審核",
    posterExpiry: "連結有效期至",
    posterDownload: "下載海報",
    posterLoading: "海報準備中…",
    posterFailed: "海報生成失敗",
    posterDownloadFailed: "海報下載失敗",
    posterLinkCopied: "連結已複製",
    subtitle: "上載 original 與多個精修版本，讓客人直接對照並提出修改意見。",
    path: "R2 根目錄",
    name: "項目名稱",
    expiry: "連結到期時間",
    create: "建立項目",
    adminNamePlaceholder: "2026年7月精修",
    createDone: "項目已建立",
    createFailed: "建立失敗",
    copyClient: "複製客戶連結",
    copyEditor: "複製修圖師連結",
    linkCopied: "連結已複製",
    loadFailed: "載入失敗",
    empty: "暫時沒有精修審核項目。",
    sync: "同步 R2",
    publish: "同步並發佈",
    upload: "批量上載",
    audit: "開啟審核",
    delete: "刪除項目",
    deleteTitle: "刪除精修審核項目",
    deleteHint: "此操作會刪除該項目相關的 R2 檔案及 D1 資料，而且無法復原。請輸入項目名稱確認。",
    deleteConfirm: "輸入項目名稱",
    cancel: "取消",
    confirmDelete: "確認刪除",
    deleted: "項目已刪除",
    uploadTitle: "批量上載精修檔案",
    uploadCurrentTitle: "為這張相片上載新版本",
    chooseFolder: "先選擇版本，再多選需要上載的相片",
    chooseCurrentFile: "選擇替換相片",
    chooseFiles: "選擇相片（可多選）",
    chooseSingleFile: "選擇一張相片",
    selectVersion: "批量設定版本",
    latestVersion: "latest（每張相片自動建立下一個版本）",
    startUpload: "開始上載",
    uploading: "正在上載",
    uploadDone: "上載完成",
    compareTitle: "上載對照檢查",
    rescan: "重新掃描",
    continueUpload: "繼續上載缺失檔案",
    confirmSync: "確認並同步",
    originalCount: "original 數量",
    matched: "正確配對",
    missing: "缺失",
    extra: "多餘",
    invalid: "無效檔案",
    complete: "完整",
    missingStatus: "缺少版本",
    extraStatus: "多餘檔案",
    noFiles: "未找到 original/vN 檔案",
    noRetouchVersion: "無精修版本",
    reviewLoadFailed: "無法載入審核項目",
    expired: "審核連結已過期或無效",
    enterNameTitle: "請填寫審核人姓名",
    enterName: "姓名只用於標識本次審核，方便攝影師確認是誰提交了評論或批准。",
    enterNamePlaceholder: "請輸入你的姓名",
    startReview: "開始審核",
    continue: "進入審核",
    original: "原圖",
    latest: "最新精修",
    edit: "添加標記",
    view: "退出標記",
    version: "版本",
    versionLabel: "版本{number}",
    comment: "修改建議",
    commentPlaceholder: "請填寫修改建議",
    send: "提交建議",
    approve: "批准目前版本",
    approvedVersion: "{version}已批准",
    approvalComment: "{version}已批准",
    download: "下載目前版本",
    downloadLabel: "下載",
    downloadAll: "下載所有相片",
    downloadAllMobileTitle: "儲存所有相片",
    downloadAllMobileHint: "請長按每張相片，然後選擇「儲存到相片」",
    downloadAllMobileCount: "共 {count} 張",
    downloadAllProgress: "正在打包 {current}/{total}",
    downloadAllStarted: "已開始打包下載",
    downloadAllPartial: "已打包 {succeeded} 張，{failed} 張失敗",
    downloadAllUnsupported: "目前瀏覽器不支援流式打包下載，請改用桌面版 Chrome/Edge，或在流動裝置逐張長按儲存",
    downloading: "正在下載",
    downloaded: "下載已開始",
    downloadFailed: "下載失敗",
    noComments: "暫時沒有評論",
    saveComment: "評論已提交",
    drawingHint: "可以在圖片上圈畫以添加標記",
    zoomIn: "放大",
    zoomOut: "縮小",
    photoZoomHint: "Ctrl/⌘ + 滾輪縮放相片",
    clearDrawing: "清除圈畫",
    resetZoom: "重設縮放",
    previous: "上一張",
    next: "下一張",
    readOnly: "目前連結只讀",
    retoucherTitle: "修圖師分享連結",
    retoucher: "修圖師",
    gallery: "所有精修相片",
    allPhotos: "所有相片",
    openGallery: "開啟所有精修相片",
    closeGallery: "收起所有精修相片",
    customerTitle: "客戶精修審核",
    photographer: "攝影師",
    customer: "客戶",
    loading: "載入中…",
    deleteComment: "刪除",
    fullscreen: "單張查看",
    exitFullscreen: "關閉預覽",
    closePreview: "關閉預覽",
    showOriginal: "顯示原圖",
    showRetouched: "顯示精修圖",
    hideOriginal: "隱藏原圖",
    mobileSaveTitle: "儲存相片",
    mobileSaveHint: "請長按圖片，然後選擇「儲存到相片」",
    singleFilenameMismatchTitle: "相片檔名不符",
    singleFilenameMismatch: "你選擇的檔案「{selected}」與目前相片檔名「{expected}」不符，請確認這是正確的相片。",
    singleFilenameMismatchHint: "確認後，系統會使用目前相片的正確檔名，寫入新的精修版本資料夾。",
    singleFilenameMismatchConfirm: "確認並繼續",
    autoSyncDone: "上載完成，R2 已自動同步",
    fullscreenFailed: "無法開啟預覽",
    statusPending: "待上載",
    statusUploading: "上載中",
    statusUploaded: "已上載",
    statusFailed: "失敗",
    selectedFiles: "已選擇 {count} 個檔案",
    invalidRoot: "請輸入有效的 R2 根目錄",
    projectNameRequired: "請輸入項目名稱",
    expiryFuture: "到期時間必須晚於現在",
    expiredStatus: "已過期",
    active: "有效",
    deleting: "刪除中",
    deleteFailed: "刪除失敗",
};

export function getRetouchReviewCopy(locale) {
    return locale === "en" ? en : locale === "yue" ? yue : zh;
}

export function formatRetouchVersion(version, copy) {
    const value = String(version || "");
    const match = value.match(/^v([1-9]\d*)$/);
    if (match) return copy.versionLabel.replace("{number}", match[1]);
    if (value === "original") return copy.original;
    return value;
}
